import { render, staticRenderFns } from "./_gameResultDetail.vue?vue&type=template&id=2bd816b4&scoped=true&lang=pug&"
import script from "./_gameResultDetail.vue?vue&type=script&lang=js&"
export * from "./_gameResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./_gameResultDetail.vue?vue&type=style&index=0&id=2bd816b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd816b4",
  null
  
)

export default component.exports